import {Directive, EventEmitter, Input, Output} from '@angular/core';
import {FaseInfo, RuoloRiga} from '../../../_models/ContenitoreInfo';
import {CardFase, RigaPercorsoView} from './contenitore-percorso.model';

/** Feature 166: ingressi e uscite comuni alle tre viste del percorso (solo presentazione). */
@Directive()
export abstract class PercorsoVista {
  @Input() righe: RigaPercorsoView[] = [];
  @Input() storia = false;
  @Output() azione = new EventEmitter<CardFase>();
  @Output() storiaFase = new EventEmitter<FaseInfo>();
  protected readonly Ruolo = RuoloRiga;

  trackRiga = (_: number, riga: RigaPercorsoView) => riga.chiave;
  trackCard = (_: number, card: CardFase) => card.chiave;
}
